import { handleActions, combineActions } from 'redux-actions'
import { combineReducers } from 'redux'

import * as actions from './actions'


const status = handleActions({
  [actions.fetchCalendarStatusSuccess]: (state, action) => {
    return {
      connected: action.payload.connected,
      calendar: action.payload.calendar,
      googleAuthed: !!action.payload.googleAuthed,
      microsoftAuthed: !!action.payload.microsoftAuthed,
      calendarStatusFetchStatus: 'success',
    }
  },
}, {})

const fetchCalendarsStatus = handleActions({
  [combineActions(actions.fetchGoogleCalendarsPending, actions.fetchMicrosoftCalendarsPending)]: () => 'pending',
  [combineActions(actions.fetchGoogleCalendarsSuccess, actions.fetchMicrosoftCalendarsSuccess)]: () => 'success'
}, null)

const calendars = handleActions({
  [combineActions(actions.fetchGoogleCalendarsSuccess, actions.fetchMicrosoftCalendarsSuccess)]: (
    state,
    action
  ) => {
    return state.calendars = action.payload
  }
}, [])

const schedulingSettings = handleActions({
  [combineActions(
    actions.updateDefaultMeetingSettingsSuccess, 
    actions.fetchDefaultMeetingSettingsSuccess)
  ]: (state, action) => {
    return action.payload
  }
}, {})

export default combineReducers({ status, calendars, fetchCalendarsStatus, schedulingSettings })



// WEBPACK FOOTER //
// ./src/modules/meetings/reducer.js